'use strict';

var cov_2p6n7z69ft = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Logo/lib/Logo.js',
      hash = '0b7df7825f8425fc3b4d800b0bd15ad30869f970',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Logo/lib/Logo.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 11,
          column: 1
        }
      },
      '1': {
        start: {
          line: 13,
          column: 13
        },
        end: {
          line: 22,
          column: 1
        }
      },
      '2': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      },
      '3': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 16
        }
      },
      '4': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      '5': {
        start: {
          line: 24,
          column: 0
        },
        end: {
          line: 28,
          column: 2
        }
      },
      '6': {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 32,
          column: 1
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 14
          }
        },
        loc: {
          start: {
            line: 13,
            column: 21
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 13
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        }, {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        }],
        line: 14
      },
      '1': {
        loc: {
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 14,
            column: 25
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 14,
            column: 11
          }
        }, {
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 14,
            column: 25
          }
        }],
        line: 14
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  & > img {\n    width: 100%;\n    max-width: 100%;\n  }\n'], ['\n  & > img {\n    width: 100%;\n    max-width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (cov_2p6n7z69ft.s[0]++, _styledComponents2.default.div(_templateObject));

cov_2p6n7z69ft.s[1]++;
var Logo = function Logo(props) {
  cov_2p6n7z69ft.f[0]++;
  cov_2p6n7z69ft.s[2]++;

  if ((cov_2p6n7z69ft.b[1][0]++, !props) || (cov_2p6n7z69ft.b[1][1]++, !props.src)) {
    cov_2p6n7z69ft.b[0][0]++;
    cov_2p6n7z69ft.s[3]++;

    return null;
  } else {
    cov_2p6n7z69ft.b[0][1]++;
  }
  cov_2p6n7z69ft.s[4]++;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement('img', (0, _extends3.default)({ alt: props.alt }, props, { src: props.src }))
  );
};

cov_2p6n7z69ft.s[5]++;
Logo.propTypes = {
  src: _propTypes2.default.string.isRequired,
  /* Alt content of icon - Use for accessibility */
  alt: _propTypes2.default.string
};

cov_2p6n7z69ft.s[6]++;
Logo.defaultProps = {
  alt: 'Logo'
};

exports.default = Logo;